import React from 'react';
import { C, font, serif } from '../shared/constants';
import { useScrollReveal, revealStyle } from '../shared';

const STEPS = [
  { num: '01', title: 'Arma tu árbol',             body: 'Diez mundos con misiones, milestones y OKR. Sabe qué sigue y llena lo que ya tienes.', color: C.turquesa },
  { num: '02', title: 'Conoce proyectos',           body: 'Cartas de emprendedores reales: dónde van, qué venden y qué aprendieron.',             color: C.turquesa },
  { num: '03', title: 'Anota lo que aprendes',       body: 'Aciertos y errores por misión. Comparte lo que quieras con la red.',                   color: C.coral },
  { num: '04', title: 'Pide ayuda a Genio y Luca',   body: 'Dos inteligencias que leen tu árbol y tus notas y te ayudan a pensar.',               color: C.mango },
  { num: '05', title: '¿Sin idea aún? Radar',        body: '31 formas reales de generar ingresos y cuál se adapta a ti.',                         color: C.coral },
];

export default function Pasos5({ isMobile, isTablet }) {
  const reveal = useScrollReveal();
  const mob = isMobile;

  return (
    <section
      ref={reveal.ref}
      style={{
        maxWidth: 1180, margin: '0 auto',
        padding: mob ? '2.5rem 1rem' : '4rem 1.5rem',
        borderTop: `1px solid ${C.border}`,
        ...revealStyle(reveal.inView),
      }}
    >
      <p style={{
        fontSize: mob ? 11 : 12, letterSpacing: 3, fontWeight: 700,
        textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)',
        margin: '0 0 24px', textAlign: 'center',
      }}>
        Lo que encuentras al entrar · en este orden
      </p>

      <div style={{
        display: 'grid',
        gridTemplateColumns: mob ? '1fr' : isTablet ? '1fr 1fr' : 'repeat(5, 1fr)',
        gap: 12, textAlign: 'left',
      }}>
        {STEPS.map((s, i) => (
          <div
            key={i}
            style={{
              background: 'rgba(255,255,255,0.04)',
              border: `1px solid ${C.border}`,
              borderTop: `3px solid ${s.color}`,
              borderRadius: 16, padding: 20,
              transition: 'transform 0.4s cubic-bezier(.16,1,.3,1), box-shadow 0.4s, border-color 0.3s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.boxShadow = `0 20px 50px rgba(${hexRgb(s.color)}, 0.22)`;
              e.currentTarget.style.borderColor = s.color;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = C.border;
            }}
          >
            <span style={{ fontFamily: serif, fontSize: 30, color: s.color }}>{s.num}</span>
            <strong style={{ display: 'block', fontSize: 16, margin: '6px 0', color: '#fff', transition: 'color 0.2s' }}>{s.title}</strong>
            <p style={{ margin: 0, fontSize: 13, color: 'rgba(255,255,255,0.55)', lineHeight: 1.6 }}>{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function hexRgb(hex) {
  const h = hex.replace('#', '');
  return `${parseInt(h.substring(0,2),16)},${parseInt(h.substring(2,4),16)},${parseInt(h.substring(4,6),16)}`;
}
